const CaptchaTypeStatus = {
	OK: 'Ok',
	STATISTICS: 'Statisztika',
	TODELETE: 'Törlésre'
};

export default CaptchaTypeStatus;
